// eslint-disable-next-line
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import styles from './index.scss';

// const closeImg = require('./../../../../assets/images/close.svg');
import IconCircleClose from '../../../IconCircleClose';
// import IconClose from '../../../IconClose';

const Popup = ({ heading, children, onClose }) => (
    <div className={styles.modalContainerWrapper}>
        <div className={styles.modalContainer}>
            <div className={styles.modalHeader}>
                <div className={styles.modalHeaderTitle}>
                    {heading.match(/</) ? (
                        <p
                            className={styles.modalHeaderText}
                            dangerouslySetInnerHTML={{ __html: heading }}
                        />
                    ) : (
                        <p className={styles.modalHeaderText}>{heading}</p>
                    )}
                </div>
                <button onClick={onClose} className={`${styles.modalCloseButton} iconButton`}>
                    <IconCircleClose fill="#999999" />
                </button>
            </div>
            <div className={`${styles.modalContent} custom-list`}>{children}</div>
        </div>
    </div>
);

Popup.propTypes = {
    onClose: PropTypes.func.isRequired,
    heading: PropTypes.string,
    children: PropTypes.node,
};

Popup.defaultProps = {
    heading: '',
    children: null,
};

export default Popup;
